import { NeoFacetPrefixApiEnum } from '../../../api/mentions/model/neo-facet-prefix-api.enum';

export enum TermTypesEnum {
    WORDS = 'WORDS',
    HANDLES = 'HANDLES',
    HASHTAGS = 'HASHTAGS'
}

export const termTypesToNeoFacetPrefixMap: Map<TermTypesEnum, NeoFacetPrefixApiEnum> = new Map([
    [TermTypesEnum.WORDS, NeoFacetPrefixApiEnum.words],
    [TermTypesEnum.HANDLES, NeoFacetPrefixApiEnum.handle],
    [TermTypesEnum.HASHTAGS, NeoFacetPrefixApiEnum.hashtag]
]);
